import React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from './utils';

const buttonVariants = cva('sc-inline-flex sc-items-center sc-justify-center sc-gap-2 sc-whitespace-nowrap sc-rounded-md sc-text-sm sc-font-semibold sc-transition-colors focus-visible:sc-outline-none focus-visible:sc-ring-2 focus-visible:sc-ring-ring focus-visible:sc-ring-offset-2 disabled:sc-pointer-events-none disabled:sc-opacity-50', {
  variants: {
    variant: {
      default: 'sc-bg-primary sc-text-primary-foreground hover:sc-bg-primary/90',
      outline: 'sc-border sc-border-solid sc-border-border sc-bg-background sc-text-foreground hover:sc-bg-muted',
      ghost: 'sc-bg-transparent sc-text-muted-foreground hover:sc-bg-muted hover:sc-text-foreground',
    },
    size: { default: 'sc-h-10 sc-px-4 sc-py-2', sm: 'sc-h-9 sc-px-3', icon: 'sc-h-9 sc-w-9 sc-p-0' },
  }, defaultVariants: { variant: 'default', size: 'default' },
});
export const Button = React.forwardRef(({ className, variant, size, asChild = false, type, ...props }, ref) => {
  const Component = asChild ? Slot : 'button';
  return <Component ref={ref} type={asChild ? undefined : type || 'button'} className={cn('pegasus-button', buttonVariants({ variant, size }), className)} {...props} />;
});
Button.displayName = 'Button';
